import 'babel-polyfill';
import React from 'react';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { Router, match, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import cookie from 'react-cookie';
import 'highlight.js/styles/googlecode.css';

// import 'semantic-ui-css/semantic.css';
import 'sp-semantic-ui/semantic/dist/themes/landing/semantic.css';
import './styles/util.scss';
import './styles/icons.scss';
import './styles/overrides.scss';
import './styles';

import createStore from './store';
import createRoutes from './routes';

let initialState = {};
const stateDiv = document.getElementById('__INITIAL_STATE__');
if (stateDiv) {
  let stateStr = stateDiv.textContent || stateDiv.innerText || stateDiv.innerHTML || '{}';
  stateStr = stateStr.replace(/\\u003c/g, '<');
  initialState = JSON.parse(stateStr);
}

const store = createStore(browserHistory, initialState, window);
const routes = createRoutes(store);

if (window.localStorage !== undefined) {
  const referrer = _.get(initialState, 'auth.referrer', null);
  if (referrer) {
    cookie.save('referrer', referrer, { path: '/', maxAge: 604800 });
  }
}
const user = _.get(initialState, 'auth.user', null);
if (!user) {
  const registrationParams = _.get(initialState, 'auth.registrationParams', null);
  if (registrationParams) {
    cookie.save('registrationParams', JSON.stringify(registrationParams), { path: '/', maxAge: 604800 });
  }
}

match({ history: browserHistory, routes }, (err, redirect, props) => {
  if (err) {
    throw err;
  }
  ReactDOM.render(
    <Provider store={store}>
      <Router {...props} />
    </Provider>
    , document.getElementById('app'));
});



// WEBPACK FOOTER //
// ./app/index.jsx